module.exports = __webpack_public_path__ + "images/utt-fba6cd.svg";